import { PlainButton } from "@jugl-web/ui-kit";
import { useToast, useTranslations } from "@jugl-web/utils";
import { useClipboard } from "@jugl-web/utils/hooks/useClipboard";
import React, { useCallback } from "react";
import { ReactComponent as CopyIcon } from "./assets/copy.svg";

export const DomainRecordCopyCell: React.FC<{
  value: string;
}> = ({ value }) => {
  const { t } = useTranslations();
  const { toast } = useToast();
  const { copyToClipboard } = useClipboard();

  const handleCopy = useCallback(async () => {
    try {
      await copyToClipboard(value);
    } catch {
      toast(
        t({
          id: "feedback.something-went-wrong",
          defaultMessage: "Something went wrong",
        }),
        { variant: "error" }
      );
    }
  }, [copyToClipboard, t, toast, value]);

  return (
    <div className="flex w-full min-w-0 items-center gap-3">
      <span className="min-w-0 flex-1 truncate">{value}</span>
      <PlainButton className="shrink-0" onClick={handleCopy}>
        <CopyIcon />
      </PlainButton>
    </div>
  );
};
